module.exports={MASONRY:{NO_ITEMS:"Products will be available from January 8th on"}};